import React from "react"

interface ServiceCardProps {
  service: any
  onBook: (service: any) => void
}

export function ServiceCard({ service, onBook }: ServiceCardProps) {
  return (
    <div
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: "8px",
        padding: "16px",
        backgroundColor: "white",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
      }}
    >
      {service.imageUrl && (
        <img
          src={service.imageUrl}
          alt={service.name}
          style={{
            width: "100%",
            height: "120px",
            objectFit: "cover",
            borderRadius: "6px",
            marginBottom: "12px",
          }}
        />
      )}
      
      <h4 style={{ fontSize: "16px", fontWeight: "600", margin: "0 0 8px 0" }}>
        {service.name}
      </h4>
      
      <p style={{ fontSize: "14px", color: "#6b7280", margin: "0 0 12px 0", lineHeight: "1.4" }}>
        {service.description}
      </p>
      
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <span style={{ fontSize: "18px", fontWeight: "700", color: "#1f2937" }}>
            {service.currency} {service.price}
          </span>
          {service.duration && (
            <div style={{ fontSize: "12px", color: "#6b7280" }}>
              {service.duration} minutes
            </div>
          )}
        </div>
        
        <button
          onClick={() => onBook(service)}
          style={{
            padding: "8px 16px",
            backgroundColor: "#3b82f6",
            color: "white",
            border: "none",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "500",
            cursor: "pointer",
          }}
        >
          Book Now
        </button>
      </div>
    </div>
  )
}